import { createStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { compose } from 'recompose';
import { withBaseProps } from '../../Utils/Component';
const styles = (theme) => createStyles({
    oilSteelBackgroundContainer: {
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'hidden',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        backgroundColor: theme.color.background.body,
        padding: 0,
        margin: 0,
        position: 'relative',
        zIndex: 100,
        minHeight: '100vh',
    },
    tritecnicalLogo: {
        position: 'absolute',
        top: '5%',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 105,
        width: 350,
    },
});
const TritecnicaBackground = (props) => {
    const { classes, children, hideLogo, imagesBaseUrl } = props;
    return (React.createElement("main", { className: classes.oilSteelBackgroundContainer, "data-testid": 'tritecnica-page' },
        !hideLogo && (React.createElement("img", { alt: 'tritecnica', src: `${imagesBaseUrl}/tritecnica/assets/images/common/logo/logo.png`, className: classes.tritecnicalLogo })),
        children));
};
export default compose(withBaseProps({ styles }))(TritecnicaBackground);
//# sourceMappingURL=TritecnicaBackground.js.map